import actionTypes from '../../actions/actionTypes'
import requestStatus from '../../constants/requestStatus'
import { Map, fromJS } from 'immutable';

const INIT_STATE = Map({
    activeUpdateText: null,
    displayUpdateHistory: false
})

function setActiveUpdateText(state, action){
    return state.set('activeUpdateText', action.payload.activeUpdateTextID);
}

function setDisplayUpdateHistory(state, action){
    return state.set('displayUpdateHistory', action.payload.displayUpdateHistory);
}


function settingsReducer(state = INIT_STATE, action) {
    
    if(action === undefined){
        return state;
    }

    switch(action.type){
        case actionTypes.DASHBOARD_SET_ACTIVE_UPDATETEXT:
            return setActiveUpdateText(state, action);
        case actionTypes.DASHBOARD_SET_DISPLAY_UPDATEHISTORY:
            return setDisplayUpdateHistory(state, action);
        default:
            return state;
    }
}

export default settingsReducer;